// Operation error is considered by the application as KO in the view
export var E_STATUS;
(function (E_STATUS) {
    E_STATUS["OK"] = "OK";
    E_STATUS["UNKNOWN"] = "NA";
    E_STATUS["KO"] = "KO";
})(E_STATUS || (E_STATUS = {}));
export var E_REQUEST_STATUS;
(function (E_REQUEST_STATUS) {
    E_REQUEST_STATUS["IDLE"] = "idle";
    E_REQUEST_STATUS["LOADING"] = "loading";
    E_REQUEST_STATUS["FINISHED"] = "finished";
})(E_REQUEST_STATUS || (E_REQUEST_STATUS = {}));
